import { Component} from '@angular/core';

@Component({
	selector: 'app-debug-watch',
	templateUrl: './watch.component.html'
})

export class WatchComponent {}



// WEBPACK FOOTER //
// ./src/app/components/watch.component.ts